import {
  ADD_WEBHOOK,
  REPLACE_WEBHOOK,
  SET_WEBHOOKS,
  SET_USER_VISIBLE_COLUMNS
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_WEBHOOKS](state, webhooks) {
    state.webhooks = webhooks;
  },
  [ADD_WEBHOOK](state, webhook) {
    state.webhooks = [webhook, ...state.webhooks];
  },
  [REPLACE_WEBHOOK](state, webhook) {
    const index = state.webhooks.findIndex(wh => wh.id === webhook.id);
    if (index >= 0) {
      state.webhooks.splice(index, 1, webhook);
    }
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  }
};